import React, { useContext, useEffect } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import { Context } from '../../../context/global-data-provider';
import PostLgReactionsProvider from '../../../context/post-lg-reactions-provider';

import MainLoading from '../../components/loading/main-loading';
import E404 from '../error/e404';
import PostLg from '../../containers/post/post-lg';
import PostSm from '../../containers/post/post-sm';
import { Helmet } from 'react-helmet';

function Post() {
  const { id } = useParams();
  const { setCurrentRoute, options, post } = useContext(Context);
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 736px)' });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 735px)' });

  useEffect(() => {
    setCurrentRoute('/post');
    document.body.classList.add('page-post');

    post.loadData(id);

    return () => {
      document.body.classList.remove('page-post');
    };
  }, [id]);

  const scrollTop = () => {
    window.scrollTo(0, 0);
  };

  if (post.loaded === 'ok') {
    if (isDesktopOrLaptop) {
      scrollTop();
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>{options.title + ' • ' + (post.data?.title?.length ? post.data?.title : id)}</title>
          <meta
            name="description"
            content={
              post.data.metaDescription?.length
                ? post.data.metaDescription
                : `${post.data?.title ? post.data.title : post.data.category.title} - ${post.data.id}`
            }
          />
          <meta property="og:type" content="article" />
          <meta property="og:title" content={options.title + ' • ' + (post.data?.title?.length ? post.data?.title : id)} />
          <meta property="og:url" content={window.location.hostname + '/post/' + post.data.id} />
          <meta property="og:image" content={post.data.media[0]} />
          <meta
            property="og:description"
            content={
              post.data.metaDescription?.length ? post.data.metaDescription : post.data?.title + ' - ' + post.data.id
            }
          />
        </Helmet>

        {isTabletOrMobile && (
          <Switch>
            <Route exact path={'/post/:id'}>
              <PostSm />
            </Route>
            <Route path={'*'} component={E404} />
          </Switch>
        )}
        {isDesktopOrLaptop && (
          <Switch>
            <Route exact path={'/post/:id'}>
              <PostLgReactionsProvider>
                <PostLg />
              </PostLgReactionsProvider>
            </Route>
            <Route path={'*'} component={E404} />
          </Switch>
        )}
      </React.Fragment>
    );
  } else {
    if (post.loaded === 'loading') {
      return <MainLoading />;
    } else {
      return <E404 />;
    }
  }
}

export default Post;
